import EventListingPrimaryView from '../EventListingPrimaryView';
import EventListingViewMode from '../EventListingViewMode';
import EventsListProductionsView from './EventsListProductionsView';
import DataStore from '../api/DataStore';

class EventsListView extends EventListingPrimaryView {
  constructor(config, keywordFilter, viewToggle) {
    const store = new DataStore();

    super(config, keywordFilter, viewToggle, store);

    this.store.on('date', this.fetchData.bind(this));

    this.resultsView = new EventsListProductionsView(this.store, this.config);
  }

  getCurrentView() {
    return this.resultsView;
  }

  getChildViews() {
    return [this.resultsView];
  }
}

EventsListView.ViewMode = EventListingViewMode.LIST;

export default EventsListView;
